module.exports = __webpack_public_path__ + "media/images/Bolscher_FavIcon-70a2e17ee15dc37c4306d1843e87b123.ico";